module.exports = __webpack_public_path__ + "media/customizations/royaloaks/logo-e664fe1658eb8c4a547e07f358996220.png";